export default __webpack_public_path__ + "static/media/Zed Cube.da57b5d0.png";